import { Input, Select } from "antd";

export default (editData = {}) => [
  {
    label: "Нэр",
    name: "labelMn",
    rules: [{ required: true, message: "Төрлийн нэрийг оруулна уу!" }],
    className: "col-span-12 md:col-span-12 mb-0",
    inputProps: {
      placeholder: "Төрлийн нэр",
      className: "w-full",
    },
  },
  {
    label: "Код",
    name: "groupKey",
    className: "col-span-12 md:col-span-6 mb-0",
    type: "input",
  },
  {
    label: "Оруулах төрөл",
    name: "valueType",
    rules: [{ required: true, message: "Утгын төрлийг сонгоно уу!" }],
    type: "select",
    className: "col-span-12 md:col-span-6 mb-0",
    inputProps: {
      className: "w-full",
      options: [
        { value: "number", label: "Тоо" },
        { value: "textarea", label: "Текст" },
        { value: "checkbox", label: "Check" },
      ],
    },
  },
  {
    label: "Төлөв",
    name: "isActive",
    rules: [{ required: true, message: "Төхөөрөмж сонгоно уу!" }],
    className: "col-span-12  md:col-span-6 mb-0",
    type: "select",
    inputProps: {
      className: "w-full",

      options: [
        { value: true, label: "Идэвхтэй" },
        { value: false, label: "Идэвхгүй" },
      ],
    },
  },
];
